import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'ca-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TagComponent {
    public type = input<string>();
    public tooltip = input<string>();
    public outline = input<boolean>(false);
    public rounded = input<boolean>(false);
}
